import {qs} from '@shared/helpers/queryString'

import {OrderSheetPageSet, OrderSheetPageSetType} from '@web/core/constants'
import getApi, {createWrapper} from '@web/helpers/api'

import {
    AddAddressResponse,
    CommonAddressBookResponse,
    DeliveryForm,
    DeliveryPayload,
    EditAddressBookResponse,
    GetAddressBookResponse,
} from './interfaces'

const api = getApi(`/orderApi`)

const ApiUrlByGroup = {
    [OrderSheetPageSet.MALL]: {
        personalCustomsClearance: '/orderSheet/mall/personalCustomsClearance',
        personalCustomsClearanceSelf: '/orderSheet/mall/personalCustomsClearance/self',
        personalCustomsClearanceEdit: '/orderSheet/mall/personalCustomsClearance/edit',
        personalCustomsClearanceAddressAddible: '/orderSheet/mall/personalCustomsClearance/address/addible',
        personalCustomsClearanceAddressRegistered: '/orderSheet/mall/personalCustomsClearance/address/registered',
        personalCustomsClearanceAddressRecentDelete: '/orderSheet/mall/personalCustomsClearance/address/recent',
    },
    [OrderSheetPageSet.EASYBOOKING]: {
        personalCustomsClearance: '/orderSheet/easyBooking/personalCustomsClearance',
        personalCustomsClearanceSelf: '/orderSheet/easyBooking/personalCustomsClearance/self',
        personalCustomsClearanceEdit: '/orderSheet/easyBooking/personalCustomsClearance/edit',
        personalCustomsClearanceAddressAddible: '/orderSheet/easyBooking/personalCustomsClearance/address/addible',
        personalCustomsClearanceAddressRegistered:
            '/orderSheet/easyBooking/personalCustomsClearance/address/registered',
        personalCustomsClearanceAddressRecentDelete: '/orderSheet/easyBooking/personalCustomsClearance/address/recent',
    },
    [OrderSheetPageSet.SELLER]: {
        personalCustomsClearance: '/orderSheet/seller/personalCustomsClearance',
        personalCustomsClearanceSelf: '/orderSheet/seller/personalCustomsClearance/self',
        personalCustomsClearanceEdit: '/orderSheet/seller/personalCustomsClearance/edit',
        personalCustomsClearanceAddressAddible: '/orderSheet/seller/personalCustomsClearance/address/addible',
        personalCustomsClearanceAddressRegistered: '/orderSheet/seller/personalCustomsClearance/address/registered',
        personalCustomsClearanceAddressRecentDelete: '/orderSheet/seller/personalCustomsClearance/address/recent',
    },
    // 패밀리 결제는 배송지 조회가 없습니다.
    [OrderSheetPageSet.FAMILY_PAY]: {
        personalCustomsClearance: '',
        personalCustomsClearanceSelf: '',
        personalCustomsClearanceEdit: '',
        personalCustomsClearanceAddressAddible: '',
        personalCustomsClearanceAddressRegistered: '',
        personalCustomsClearanceAddressRecentDelete: '',
    },
    // 클레임 비용결제는 배송지 조회가 없습니다.
    [OrderSheetPageSet.CLAIM]: {
        personalCustomsClearance: '',
        personalCustomsClearanceSelf: '',
        personalCustomsClearanceEdit: '',
        personalCustomsClearanceAddressAddible: '',
        personalCustomsClearanceAddressRegistered: '',
        personalCustomsClearanceAddressRecentDelete: '',
    },
}

/** 통관고유부호의 본인 OR 타인 확인 */
const checkSelf = async ({pageSet, name, phone}: {pageSet: OrderSheetPageSetType; name: string; phone: string}) => {
    const url = ApiUrlByGroup[pageSet].personalCustomsClearanceSelf
    return createWrapper<{
        valid: boolean
    }>(
        api.post(url, {
            name,
            phone,
        }),
    )
}

/** 관세청 에서 개인통관 고유부호 조회 */
const getCode = async ({
    pageSet,
    entry,
    ...data
}: {
    pageSet: OrderSheetPageSetType
    entry: string
    name: string
    phone: string
    id: string
    zipCode: string
    code?: string
}) => {
    const url = ApiUrlByGroup[pageSet].personalCustomsClearance
    return createWrapper<{
        valid: boolean
        personalCustomCode: string
        hash: string
        errorTypes: string[]
    }>(api.post(`${url}?entry=${entry}`, data))
}

/** 개인통관 고유부호 에 지정된 배송지 수정 */
const editAddressBook = async ({
    pageSet,
    hash,
    address,
}: {
    pageSet: OrderSheetPageSetType
    hash: string
    address: DeliveryForm
}) => {
    const url = ApiUrlByGroup[pageSet].personalCustomsClearanceEdit
    return createWrapper<EditAddressBookResponse>(
        api.put(
            qs.stringifyUrl({
                url,
                query: {
                    hash,
                },
            }),
            {address},
        ),
    )
}

/** 배송지 목록 조회 */
const getAddressBook = ({pageSet}: {pageSet: OrderSheetPageSetType}) => {
    const url = ApiUrlByGroup[pageSet].personalCustomsClearanceAddressAddible
    return createWrapper<GetAddressBookResponse>(api.get(url))
}

/** 배송지 추가 */
const addAddressBook = ({
    pageSet,
    address,
}: {
    pageSet: OrderSheetPageSetType
    address: Omit<DeliveryPayload, 'setAsVirtualPhoneNumberUsed'>
}) => {
    const url = ApiUrlByGroup[pageSet].personalCustomsClearanceAddressRegistered
    return createWrapper<AddAddressResponse>(api.post(url, {address}))
}

/** 배송지 삭제 */
const deleteAddressBook = ({pageSet, hash}: {pageSet: OrderSheetPageSetType; hash: string}) => {
    const url = ApiUrlByGroup[pageSet].personalCustomsClearanceAddressRecentDelete
    return createWrapper<CommonAddressBookResponse>(
        api.delete(
            qs.stringifyUrl({
                url,
                query: {
                    hash,
                },
            }),
        ),
    )
}

export default {
    checkSelf,
    getCode,
    editAddressBook,
    getAddressBook,
    addAddressBook,
    deleteAddressBook,
}
